import { useSearchParams } from 'react-router-dom';
import { CREDITS_DASHBOARD_PARAM } from './constants';

export const useCreditsDashboardDrawer = () => {
    const [params, setParams] = useSearchParams();
    const isOpen = params.get(CREDITS_DASHBOARD_PARAM) === 'true';

    const open = () => {
        params.set(CREDITS_DASHBOARD_PARAM, 'true');
        setParams(params);
    };
    const close = () => {
        params.delete(CREDITS_DASHBOARD_PARAM);
        setParams(params);
    };

    return { isOpen, open, close };
};
